import {Utility} from "@reapptor-apps/reapptor-toolkit";
import {PageRoute} from "@reapptor-apps/reapptor-react-common";
import {CruiseDuration, CruiseExtra, CruiseGroupSize, CruiseTimeOfDay, VisitingPointDuration} from "@/models/Enums";
import CruiseArea from "@/models/server/CruiseArea";
import CruiseCountry from "@/models/server/CruiseCountry";

export default class WizardContext {
    public actionInitialPageRoute: PageRoute | null = null;

    public call: boolean = false;

    public country: CruiseCountry | null = null;

    public area: CruiseArea | null = null;

    public departBy: Date | null = null;

    public departFrom: string | null = null;

    public visitPoint: string | null = null;

    public visitingPointDuration: VisitingPointDuration | null = null;

    public arriveAt: Date | null = null;

    public arriveTo: string | null = null;

    public customArea: string | null = null;

    public groupSize: CruiseGroupSize | null = null;

    public timeOfDay: CruiseTimeOfDay | null = null;

    public duration: CruiseDuration | null = null;

    public date: Date = Utility.today();

    public extras: CruiseExtra[] = [];

    public groupSizeValue: number = 0;

    public childrenComing: boolean = false;

    public numberOfComingChildren: number | null = null;

    public accessibilityLimitations: boolean = false;

    public accessibilityLimitationsComment: string | null = null;

    public estimatedPrice: number | null = null;

    public comment: string = "";

    public name: string = "";

    public company: string = "";

    public email: string = "";

    public phone: string = "";

    public agreementAccepted: boolean = false;

    public registrationAccepted: boolean = false;

    public cancellationPolicyAccepted: boolean = false;

    public completed: boolean = false;

    public sending: boolean = false;
    
    public static getVisitingPointDurationTimeOffset(context: WizardContext): number {
        if (context.visitingPointDuration == null) {
            return 0;
        }
        
        switch (context.visitingPointDuration) {
            case VisitingPointDuration.Min10:
            case VisitingPointDuration.Min30:
            case VisitingPointDuration.H1: return 1;
            case VisitingPointDuration.H2: return 2;
            case VisitingPointDuration.H3: return 3;
            case VisitingPointDuration.H4: return 4;
            case VisitingPointDuration.H5: return 5;
            
            default: return 0;
        }
    }
    
    public static getCruiseDuration(context: WizardContext): number | null {
        if (context.arriveAt && context.departBy) {
            return Math.round(Utility.diff(context.arriveAt, context.departBy).totalHours);
        }
        
        return null;
    }

    public static setCruiseDuration(context: WizardContext): void {
        const duration: number | null = this.getCruiseDuration(context);
        
        if (duration) {
            switch (duration) {
                case 1:
                    context.duration = CruiseDuration.H1;
                    break;
                case 2:
                    context.duration = CruiseDuration.H2;
                    break;
                case 3:
                    context.duration = CruiseDuration.H3;
                    break;
                case 4:
                    context.duration = CruiseDuration.H4;
                    break;
                default:
                    context.duration = CruiseDuration.H5;
                    break;
            }
        }
    }

    public static setCruiseTimeOfDay(context: WizardContext): void {
        if (context.departBy) {
            const hours: number = context.departBy.getHours();

            context.timeOfDay = (hours < 12)
                ? CruiseTimeOfDay.Morning
                : (hours < 16)
                    ? CruiseTimeOfDay.Day
                    : CruiseTimeOfDay.Evening;
        }
    }
}